import { ApiResponse, Lead, MediaFile, VehicleStatus } from '../models';
import * as http from './http';
import ApiService from './service';

export class QuotationService extends ApiService {
  async createQuotation(data: {
    withVIN: boolean;
    vehicleId?: string;
    sku: string;
    request?: boolean;
    mode?: 'assignment' | 'transfer';
    leadId: string;
    configId: string;
  }) {
    const url = `${this.apiDomain}/api/quotation`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }

  async assignVINNumber(data: {
    withVIN: boolean;
    vehicleId?: string;
    sku: string;
    request?: boolean;
    mode?: 'assignment' | 'transfer';
    leadId: string;
    configId: string;
    vehicleStatus?: Omit<VehicleStatus[], 'Available' | 'Demo'>;
    isPreVin?: boolean;
    comment?: string;
    damageWaiverFile?: MediaFile;
  }) {
    const url = `${this.apiDomain}/api/quotation/vin`;
    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }
}
